// modules
import { handleActions } from 'redux-actions'

// constants
import { MEASUREMENT_TAB_LIST } from 'src/constants'

// actions
import {
  setMeasurementList,
  setMeasurementPatientList,
  setMeasurementPatientListAssigned,
  setMeasurementPatientReadingList,
  setMeasurementPatientReadingValue,
  setMeasurementPatientValue,
  setMeasurementValue,
  setMeasurementPatientReadingAnswer,
  setMeasurementPredefinedFilter,
  setMeasurementActiveTab,
  setMeasurementDashboardList,
  resetMeasurement,
  setMeasurementChartInfo,
  setIsLoadingSync
} from 'src/store/modules/patient/measurements'

import { deletePatientData } from 'src/store/modules/actionCreators'

const initialState = {
  measurementList: [],
  measurementValue: {},
  measurementPatientList: [],
  measurementDashboardList: [],
  measurementPatientListAssigned: [],
  measurementPatientValue: {},
  measurementPatientReadingList: [],
  measurementPatientReadingValue: {},
  measurementPatientReadingAnswer: {},
  measurementPredefinedFilter: {},
  measurementActiveTab: MEASUREMENT_TAB_LIST[0],
  measurementChartInfo: {},
  loadingSync: {}
}

export default handleActions(
  {
    [setMeasurementList](state, { payload: measurementList }) {
      return {
        ...state,
        measurementList
      }
    },

    [setMeasurementValue](state, { payload: measurementValue }) {
      return {
        ...state,
        measurementValue
      }
    },

    [setMeasurementPatientList](state, { payload: measurementPatientList }) {
      return {
        ...state,
        measurementPatientList
      }
    },

    [setMeasurementDashboardList](
      state,
      { payload: measurementDashboardList }
    ) {
      return {
        ...state,
        measurementDashboardList
      }
    },

    [setMeasurementPatientListAssigned](
      state,
      { payload: measurementPatientListAssigned }
    ) {
      return {
        ...state,
        measurementPatientListAssigned
      }
    },

    [setMeasurementPatientValue](state, { payload: measurementPatientValue }) {
      return {
        ...state,
        measurementPatientValue
      }
    },

    [setMeasurementPatientReadingList](
      state,
      { payload: measurementPatientReadingList }
    ) {
      return {
        ...state,
        measurementPatientReadingList
      }
    },

    [setMeasurementPatientReadingValue](
      state,
      { payload: measurementPatientReadingValue }
    ) {
      return {
        ...state,
        measurementPatientReadingValue
      }
    },

    [setMeasurementPatientReadingAnswer](
      state,
      { payload: measurementPatientReadingAnswer }
    ) {
      return {
        ...state,
        measurementPatientReadingAnswer
      }
    },

    [setMeasurementPredefinedFilter](
      state,
      { payload: measurementPredefinedFilter }
    ) {
      return {
        ...state,
        measurementPredefinedFilter
      }
    },

    [setMeasurementActiveTab](state, { payload: measurementActiveTab }) {
      return {
        ...state,
        measurementActiveTab
      }
    },

    [setMeasurementChartInfo](state, { payload: measurementChartInfo }) {
      return {
        ...state,
        measurementChartInfo
      }
    },

    [setIsLoadingSync](state, { payload: loadingSync }) {
      return {
        ...state,
        loadingSync
      }
    },

    [resetMeasurement]() {
      return initialState
    },

    [deletePatientData]() {
      return initialState
    }
  },
  initialState
)
